// Zentrales Blog-Register. Neuer Beitrag: Datei in ./posts anlegen und hier
// importieren – Details in ./README.md.
import aiInCrm from './posts/ai-in-crm';
import nativeAppDevelopment from './posts/native-app-development';
import appDesign from './posts/app-design';
import onlineMarketing from './posts/online-marketing';
import websiteRelaunchLeitfaden from './posts/website-relaunch-leitfaden';
import barrierefreiheitWebdesign from './posts/barrierefreiheit-webdesign';

// Neueste zuerst
export const blogPosts = [
  aiInCrm,
  nativeAppDevelopment,
  appDesign,
  onlineMarketing,
  websiteRelaunchLeitfaden,
  barrierefreiheitWebdesign,
].sort((a, b) => new Date(b.date) - new Date(a.date));

export const getPostBySlug = (slug) => blogPosts.find((post) => post.slug === slug);

/** Empfehlungen: explizit verlinkte Beiträge, aufgefüllt mit den neuesten anderen. */
export const getRelatedPosts = (post, count = 2) => {
  const explicit = (post.related || [])
    .map((slug) => getPostBySlug(slug))
    .filter(Boolean);
  const fillers = blogPosts.filter(
    (p) => p.slug !== post.slug && !explicit.some((e) => e.slug === p.slug)
  );
  return [...explicit, ...fillers].slice(0, count);
};

export const formatPostDate = (isoDate) =>
  new Date(isoDate).toLocaleDateString('de-DE', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
